
 

 

 

 
class DistrictParameter 
{
    
        DistrictGroupId: string | null;
    
        DistrictId: string | null;
    
        DistrictName: string;
    
        StationId: string | null;
    
        StationName: string;
    
}
 
export default DistrictParameter;
 




